// extracted by mini-css-extract-plugin
export default {"container":"AddUserForm_container__3k+t5","form":"AddUserForm_form__S3tLv"};